import StoreModuleService from '../../../StoreModuleService';
import { initialState } from './state';
import Vue from 'vue';

// mutations declarations
export const SET_INSTALLABLE_VERSION = 'SET_INSTALLABLE_VERSION';
export const SET_INSTALLABLE_VERSIONS = 'SET_INSTALLABLE_VERSIONS';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_INSTALLABLE_VERSIONS](state, payload) {
		const { data, id: installableId, keepExisting } = payload;
		const baseVersionsObject = keepExisting ? { ...state.versionsOfInstallables[installableId] } : {};
		Vue.set(state.versionsOfInstallables, installableId, { ...baseVersionsObject, ...data });
	},
	[SET_INSTALLABLE_VERSION](state, payload) {
		const { installableVersion } = payload;
		const { id: installableVersionId, installable: installableId } = installableVersion;
		if (!state.versionsOfInstallables[installableId]) {
			Vue.set(state.versionsOfInstallables, installableId, {});
		}
		Vue.set(state.versionsOfInstallables[installableId], installableVersionId, installableVersion);
	},
};

export default mutations;
